import { Card, CardActions, CardContent, Divider, IconButton, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FC, useCallback } from "react";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import theme from "src/theme/light";
import { TIPO_HISTORICO_DESCONTO } from "..";
import { AddCircle, RemoveCircle } from "@mui/icons-material"

export interface ICardHistoricoNovo {
    selecionado?: boolean;
    tipoHistorico: number;
    historico: any;
    onClick: (id: number, tipoHistorico: number) => void;
}

const useStyles = makeStyles({
    root: {
        width: 200,
        marginTop: 10,
        marginRight: 15,
        backgroundColor: theme.palette.grey[100],
    },
    selecionado: {
        border: "3px solid " + theme.palette.primary.main,
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

const CardHistoricoNovo: FC<ICardHistoricoNovo> = ({ historico, selecionado, onClick, tipoHistorico }) => {
    const classes = useStyles();
    const maskDate = useCallback((date: string, time: boolean)=>{
        if(date){
            const data = new Date(date);
            if (time){
                const formattedData = data.toLocaleString('pt-BR', {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                });
                return formattedData;
            }else{
                const formattedData = data.toLocaleString('pt-BR', {
                    day: 'numeric',
                    month: 'numeric',
                    year: 'numeric',
                });
                return formattedData;
            }    
        }else return "-";
    },[historico?.created_at])

    return <Card 
        className={`${classes.root}${selecionado ? " " + classes.selecionado : ""}`}
        > 
        <CardContent>
            <Typography variant="h5" component="h2">
                {maskDate(historico?.created_at || "", false)}
            </Typography>
            <Divider variant="fullWidth" />
            <Typography className={classes.pos} color="textSecondary">
                {maskDate(historico?.created_at || "", true)}
            </Typography>
            {tipoHistorico !== TIPO_HISTORICO_DESCONTO && <Typography variant="body2" component="p">
                {Formater.toString(historico?.valor, TypeRecords.CURRENCY)}
            </Typography>}
            {historico?.usuario && <Typography variant="body2" component="p">
                Por: {historico?.usuario}
            </Typography>}
        </CardContent>
        
        <CardActions style={{justifyContent: "center"}}>
            <IconButton
                onClick={() => {
                    onClick(historico.id, historico.tipoHistorico);
                }}
                size="small"
            >
                {selecionado ? <RemoveCircle fontSize={"large"} style={{color: "#CB0D0D"}}/> : <AddCircle fontSize={"large"} style={{color: "#00A335"}}/>}
            </IconButton>
        </CardActions>
    </Card>
};

export { CardHistoricoNovo };